<div class="ttmodal" *ngIf="!isEdit">
  <div class="ttmodal__header">
    <span class="ttmodal__title">{{'Delete Additional Observation'| translate | async}}</span>
    <!-- <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i> -->
  </div>
  <div class="ttmodal__body about-modal">
    <div class="site-code">{{'Are you sure you want to delete this Additional Observation' | translate | async}} </div>
  </div>
  <div class="ttmodal__footer ok-button">
    <button  mat-raised-button (click)="onNoClick()">{{'No' | translate | async}}</button>
    <button  mat-raised-button class="button-yes" (click)="confirm()">{{'Yes' | translate | async}}</button>
  </div>
</div>

<div class="ttmodal edit-modal" *ngIf="isEdit">
  <div class="ttmodal__header">
    <span class="ttmodal__title">
      {{ "Edit Additional Observation" | translate | async }}<!--  {{ title }} -->
    </span>
    <!-- <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i> -->
  </div>
  <div class="ttmodal__body">
    <div>
        <mat-form-field class="input">
          <input class="titleInput" matInput placeholder="{{'Title' | translate | async}}" type="text" [(ngModel)]="title" required>
        </mat-form-field>
    </div>
  </div>
  <div class="ttmodal__footer">
    <button mat-raised-button (click)="onNoClick()"> {{ 'Cancel' | translate | async }}</button>
    <button mat-raised-button color="warn" (click)="updateAdditional()"><span class="material-icons button__icon">check</span><span class="button__text">{{ 'Edit' | translate | async }} </span></button>
  </div>
</div>